import config from '../../config';
import {
  OrganizationSubscriptionType,
  PlanType,
  UserAccountType,
} from '../../generated/graphql';
import {MemberData, TeamOrganization} from '../../graphql/teamQuery';

export enum TeamMemberRole {
  ADMIN = 'admin',
  MEMBER = 'member',
  SERVICE = 'SERVICE',
  VIEW_ONLY = 'viewer',
}

export const MEMBER_OPTION = {
  text: 'Member',
  value: TeamMemberRole.MEMBER as string,
};
const ADMIN_OPTION = {text: 'Admin', value: TeamMemberRole.ADMIN as string};
const SERVICE_ACCOUNT_OPTION = {text: 'Service', value: TeamMemberRole.SERVICE};
const VIEW_ONLY_OPTION = {
  text: 'View-Only',
  value: TeamMemberRole.VIEW_ONLY,
};

export const DEFAULT_DROPDOWN_OPTIONS = [MEMBER_OPTION, ADMIN_OPTION];

export const ROLE_MANAGEMENT_DISABLED_OPTIONS = [ADMIN_OPTION];

export function getDefaultTeamRoleOptions(
  isViewOnlyEnabled: boolean,
  viewerIsOrgAdmin: boolean,
  roleManagementEnabled: boolean,
  organization?: TeamOrganization,
  isViewerAdmin?: boolean
) {
  if (!roleManagementEnabled) {
    return ROLE_MANAGEMENT_DISABLED_OPTIONS;
  }
  // If the viewer is not an admin, they can't invite admins
  const defaultOptions = DEFAULT_DROPDOWN_OPTIONS.filter(o =>
    isViewerAdmin || viewerIsOrgAdmin ? true : o.value !== ADMIN_OPTION.value
  );
  return [
    ...(isViewOnlyEnabled ? [VIEW_ONLY_OPTION] : []),
    ...defaultOptions,
    ...getServiceAccountOption(organization),
  ];
}

export function getDefaultRoles() {
  return [VIEW_ONLY_OPTION, MEMBER_OPTION, ADMIN_OPTION];
}

export function getServiceAccountOption(organization?: TeamOrganization) {
  if (config.ENVIRONMENT_IS_PRIVATE) {
    return [SERVICE_ACCOUNT_OPTION];
  }

  if (organization == null) {
    return [];
  }

  const primarySubscription = organization.subscriptions.find(
    sub => sub.plan.planType === PlanType.Primary
  );
  if (primarySubscription == null) {
    return [];
  }

  // Only enterprise plans can create service accounts
  const {plan, subscriptionType} = primarySubscription;
  return plan.name === 'enterprise' &&
    subscriptionType === OrganizationSubscriptionType.Enterprise
    ? [SERVICE_ACCOUNT_OPTION]
    : [];
}

export function getRoleLabel(member: MemberData) {
  if (member.memberRole == null) {
    return '';
  }
  if (member.accountType === UserAccountType.Service) {
    return 'service';
  }
  if (member.pending) {
    return 'invited';
  }
  return member.memberRole.name;
}
